import type * as React from 'react';

import {
    Button,
    Card,
    CardActions,
    CardBody,
    CardImage,
    CardImageLayout,
    Description,
    Heading,
    type ImageProps,
    ProgressiveImage,
} from '@gitbook/spine-react';

/**
 * Card displaying content driven by marketing team.
 */
export function MarketingCard(props: {
    card: { title?: string; description?: string; cta?: string; url?: string } | null;
    image: ImageProps['src'];
    className?: string;
}): React.ReactElement | null {
    const { card, image, className } = props;

    if (!card || !card.title) {
        return null;
    }

    return (
        <Card className={className}>
            <CardImageLayout>
                <CardImage>
                    <ProgressiveImage src={image} width={153} height={127} />
                </CardImage>
                <CardBody>
                    <Heading>{card.title}</Heading>
                    <Description>{card.description}</Description>

                    {card.cta && (
                        <CardActions>
                            <Button kind="secondary" label={card.cta} href={card.url} />
                        </CardActions>
                    )}
                </CardBody>
            </CardImageLayout>
        </Card>
    );
}
